import { cssVarColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'

const { contentBg } = cssVarColors

export const sheet: Styles = {
  columnBlock: {},
  title: {},
  text: {},
  input: {},
  topBlock: { gap: '6px' },
  radioWrapper: { gap: '18px', paddingTop: 14 },

  radioInput: {
    marginRight: 12
  },
  formTitle: {
    marginBottom: 15
  },
  name: {},
  backgroundIcon: {},
  content: {
    backgroundColor: contentBg,
    display: 'flex',
    flexDirection: 'row',
    height: '90vh',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      height: 'max-content'
    }
  },
  textLeft: {
    position: 'relative',
    overflow: 'hidden',
    padding: '3em',
    flex: 1,
    zIndex: 1,
    gap: '40px'
  },

  form: {
    boxShadow: ' -28px 0px 50.49px 0px #0000000D',
    position: 'relative',
    flex: 1,
    gap: '20px',
    padding: '20px clamp(10px, 4vw, 80px)',
    '& > $name': {
      gap: '40px'
    }
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: '40px'
  },
  iconBlocksWrapper: {
    justifyContent: 'space-between',
    gap: '10px'
  },
  iconBlock: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  margin: {
    marginTop: '10%'
  },
  linkText: {
    fontWeight: 'normal',
    lineHeight: '20px',
    fontSize: 15,
    letterSpacing: '0.01em',
    color: '#080910'
  },
  '@media (min-width: 992px) and (max-width: 1199.98px)': {
    textLeft: {
      padding: '3em 3em 3em 1.5em'
    }
  },
  '@media (min-width: 768px) and (max-width: 991.98px)': {
    textLeft: {
      padding: '3em 1em 3em 1em',
      '& h3': {
        fontSize: 25
      }
    },
    buttonGroup: {
      margin: '1.5em 0'
    }
  }
}
